<div class="w-full flex flex-col gap-4 p-4">
    <div class="w-full flex sm:flex-row flex-col items-center justify-between gap-4">
        <h1 class="text-2xl font-bold">CFOP</h1>

        <app-button
            (click)="incluir()"
            variant="success"
            class="md:max-w-45 w-full"
        >
            Incluir
        </app-button>
    </div>

    <app-input-search
        [(ngModel)]="filtro"
        label="Pesquisar CFOP"
        class="w-full"
    ></app-input-search>

    <p-table
        [paginator]="true"
        [rows]="qtdLinhas || 7"
        [totalRecords]="usuarios.length"
        [value]="usuarios"
        [lazy]="false"
    >
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th class="w-[35%] min-w-30">Descrição</th>
                <th class="w-[30%] min-w-30">Aplicação</th>
                <th class="w-[10%] min-w-20">Cfop</th>
                <th class="w-[10%] min-w-30">Tipo de Operação</th>
                <th class="w-[10%] min-w-20">Origem</th>
                <th class="w-[5%] min-w-5">Ações</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td>{{ rowData.Descricao }}</td>
                <td>{{ rowData.Aplicacao }}</td>
                <td>{{ rowData.Cfop }}</td>
                <td>{{ rowData.TipoOperacao }}</td>
                <td>{{ rowData.Origem }}</td>
                <td>
                    <app-opcoes-table
                        [value]="rowData"
                        [opcoes]="opcoesTable"
                    ></app-opcoes-table>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
